import React, { useEffect } from "react";
import { Modal } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/pro-solid-svg-icons";
import styled from "styled-components/macro";
import {
  OverlayWrapper as SharedOverlayWrapper,
  SubmittedSubtitle,
  SubmittedTitle,
  SubmittedWrapper,
} from "./PortalFeedbackModal.styles";

const DEFAULT_AUTO_DISMISS_MS = 4000;

const OverlayWrapper = styled(SharedOverlayWrapper)`
  padding: 10px;
`;

const CardWrapper = styled(SubmittedWrapper)`
  gap: 24px;
  align-items: center;
  max-width: 360px;
`;

interface PortalFeedbackDismissModalProps {
  isOpen: boolean;
  onClose: () => void;
  bodyMessage: string;
}

export const PortalFeedbackDismissModal: React.FC<
  PortalFeedbackDismissModalProps
> = ({ isOpen, onClose, bodyMessage }) => {
  useEffect(() => {
    if (!isOpen) return;
    const timeout = setTimeout(() => {
      onClose();
    }, DEFAULT_AUTO_DISMISS_MS);
    return () => clearTimeout(timeout);
  }, [isOpen, onClose]);

  const handleWrapperClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <OverlayWrapper onClick={handleWrapperClick}>
        <CardWrapper>
          <FontAwesomeIcon
            icon={faCircleCheck}
            style={{ fontSize: "36px", color: "#60C66A" }}
          />
          <div>
            <SubmittedTitle>Got it</SubmittedTitle>
            <SubmittedSubtitle>{bodyMessage}</SubmittedSubtitle>
          </div>
        </CardWrapper>
      </OverlayWrapper>
    </Modal>
  );
};
